import type { ItemType } from '../../types';
import { itemTypeMeta } from '../../utils/itemTypeRoutes';

/**
 * Corner badge on brand-page tiles that signals a tile is NOT a polish
 * (plate, cuticle oil, embellishment, etc.). Polish tiles get no badge —
 * they're the majority, so the badge itself is the "different type" signal.
 * When collections mix types (e.g. a launch that bundled polish + plate),
 * users can tell at a glance which is which.
 *
 * Rendered as an absolute-positioned pill; parent must be `relative`.
 */
export default function TypeBadge({ itemType }: { itemType: ItemType | undefined }) {
  const meta = itemTypeMeta(itemType);
  if (!meta) return null;
  return (
    <span
      className="absolute bottom-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-slate-900/85 text-white text-[10px] font-medium backdrop-blur-sm border border-slate-500/50"
      title={meta.label}
      aria-label={meta.label}
    >
      <span aria-hidden="true">{meta.emoji}</span>
      <span>{meta.label}</span>
    </span>
  );
}
